import { AnNamElement } from "../../base-element";

// Dawn global utilities loaded via global.js before an-nam.js
declare function trapFocus(
  container: HTMLElement,
  elementToFocus?: HTMLElement | null
): void;
declare function removeTrapFocus(focusElement?: HTMLElement | null): void;

export class AnDetailsModal extends AnNamElement {
  protected detailsContainer!: HTMLDetailsElement;
  protected summaryToggle!: HTMLElement;

  protected override scheduleUpdate(): void {}

  override connectedCallback(): void {
    super.connectedCallback();
    this.detailsContainer = this.querySelector("details")!;
    this.summaryToggle = this.querySelector("summary")!;

    this.detailsContainer.addEventListener("keyup", this._onKeyUp);
    this.summaryToggle.addEventListener("click", this._onSummaryClick);
    this.querySelector('button[type="button"]')?.addEventListener(
      "click",
      this._onCloseClick
    );
    this.summaryToggle.setAttribute("role", "button");
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();
    this.detailsContainer?.removeEventListener("keyup", this._onKeyUp);
    this.summaryToggle?.removeEventListener("click", this._onSummaryClick);
    this.querySelector('button[type="button"]')?.removeEventListener(
      "click",
      this._onCloseClick
    );
    document.body.removeEventListener("click", this._onBodyClick);
  }

  private _onKeyUp = (e: KeyboardEvent): void => {
    if (e.code.toUpperCase() === "ESCAPE") this.close();
  };

  private _onSummaryClick = (e: MouseEvent): void => {
    e.preventDefault();
    (e.target as HTMLElement).closest("details")?.hasAttribute("open")
      ? this.close()
      : this.open(e);
  };

  private _onCloseClick = (): void => {
    this.close();
  };

  private _onBodyClick = (e: MouseEvent): void => {
    const target = e.target as HTMLElement;
    if (!this.contains(target) || target.classList.contains("modal-overlay")) {
      this.close(false);
    }
  };

  isOpen(): boolean {
    return this.detailsContainer.hasAttribute("open");
  }

  open(event: { target: EventTarget | null }): void {
    (event.target as HTMLElement)
      .closest("details")
      ?.setAttribute("open", "true");
    document.body.addEventListener("click", this._onBodyClick);
    document.body.classList.add("overflow-hidden");
    trapFocus(
      this.detailsContainer.querySelector<HTMLElement>('[tabindex="-1"]')!,
      this.detailsContainer.querySelector<HTMLElement>(
        "input:not([type='hidden'])"
      )
    );
  }

  close(focusToggle = true): void {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this._onBodyClick);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("an-details-modal", AnDetailsModal);
